import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePanel } from 'contexts/panelContext';
import { Box, BoxSection } from 'components/_new/Box';
import { IconSvg } from 'components/_new/Icon';
import { KnowledgeBaseArticleContentItemMeta } from 'types/KnowledgeBase';
import { slugify } from 'utils/helpers';
import './ProgressSteps.scss';

type MenteeProgressQuickLinksProps = {
	faqArticle: KnowledgeBaseArticleContentItemMeta | null;
};

const MenteeProgressQuickLinks = ({ faqArticle }: MenteeProgressQuickLinksProps) => {
	const { t } = useTranslation();
	const { panelScopePath } = usePanel();

	return (
		<div className="mentee-pair-quick-links flex flex-row flex-wrap gap-2 md:gap-4">
			<Link to={{ pathname: `${panelScopePath}/pairing` }} className="flex-1-mhalf">
				<Box className="h-full" variant="white-bordered" slim full hoverable>
					<BoxSection contentClassName="justify-content-center align-items-center text-center">
						<span className="icon-container icon-container-lg">
							<IconSvg name="user-plus" className="text-rose" />
						</span>
						<span>{t('userPanel.dashboard.quickLinks.pairPropositions')}</span>
					</BoxSection>
				</Box>
			</Link>
			<Link to={{ pathname: `${panelScopePath}/personal-details` }} className="flex-1-mhalf">
				<Box className="h-full" variant="white-bordered" slim full hoverable>
					<BoxSection contentClassName="justify-content-center align-items-center text-center">
						<span className="icon-container icon-container-lg">
							<IconSvg name="user" className="text-primary" />
						</span>
						<span>{t('userPanel.dashboard.quickLinks.yourBusinessCard')}</span>
					</BoxSection>
				</Box>
			</Link>
			{faqArticle ? (
				<Link
					to={{
						pathname: `${panelScopePath}/knowledge-base/article/${faqArticle.id}${
							faqArticle.slug ? `/${slugify(faqArticle.slug)}` : ''
						}`,
					}}
					className="flex-1-mhalf"
				>
					<Box className="h-full" variant="white-bordered" slim full hoverable>
						<BoxSection contentClassName="justify-content-center align-items-center text-center">
							<span className="icon-container icon-container-lg">
								<IconSvg name="question-mark-square" className="text-primary" />
							</span>
							<span>FAQ</span>
						</BoxSection>
					</Box>
				</Link>
			) : null}
			<Link to={{ pathname: `${panelScopePath}/knowledge-base` }} className="flex-1-mhalf">
				<Box className="h-full" variant="white-bordered" slim full hoverable>
					<BoxSection contentClassName="justify-content-center align-items-center text-center">
						<span className="icon-container icon-container-lg">
							<IconSvg name="book" className="text-primary" />
						</span>
						<span>{t('userPanel.dashboard.quickLinks.knowledgeBase')}</span>
					</BoxSection>
				</Box>
			</Link>
		</div>
	);
};

export default MenteeProgressQuickLinks;
